import type {
  CreateScheduledTaskRequest,
  ListScheduledTasksResponse,
  ScheduledTask,
  ScheduledTaskRun,
  UpdateScheduledTaskRequest,
} from "@repo/shared/types";
import { del, get, patch, post } from "./_client";

const BASE = "/internal/scheduled-tasks";

export function listScheduledTasks(): Promise<ListScheduledTasksResponse> {
  return get<ListScheduledTasksResponse>(BASE);
}

export function createScheduledTask(data: CreateScheduledTaskRequest): Promise<ScheduledTask> {
  return post<ScheduledTask>(BASE, data satisfies CreateScheduledTaskRequest);
}

export function updateScheduledTask(
  id: string,
  data: UpdateScheduledTaskRequest,
): Promise<ScheduledTask> {
  return patch<ScheduledTask>(`${BASE}/${id}`, data satisfies UpdateScheduledTaskRequest);
}

export function deleteScheduledTask(id: string): Promise<{ success: boolean }> {
  return del<{ success: boolean }>(`${BASE}/${id}`);
}

export function runScheduledTaskNow(id: string): Promise<{ success: boolean }> {
  return post<{ success: boolean }>(`${BASE}/${id}/run`, {});
}

export function cancelScheduledTask(id: string): Promise<{ success: boolean }> {
  return post<{ success: boolean }>(`${BASE}/${id}/cancel`, {});
}

export function listScheduledTaskRuns(
  id: string,
  limit = 20,
): Promise<{ runs: ScheduledTaskRun[] }> {
  return get<{ runs: ScheduledTaskRun[] }>(`${BASE}/${id}/runs?limit=${limit}`);
}
